import { getOrderDeliveryStatusBadgeProps } from '../../../../utils/order/orderDeliveryStatusDisplay';
import { getPendingListStatusBadgeProps } from './pendingRowStatusDisplay';
import PendingListStatusBadge from './PendingListStatusBadge';

/** @param {string} [badgeVariant] 待办 tab 主题色；未传则用订单语义色（danger/success） */
const OrderDeliveryStatusCell = ({ deliveryStatus, badgeVariant }) => {
	if (!deliveryStatus) {
		return <span>-</span>;
	}

	const props = badgeVariant
		? getPendingListStatusBadgeProps(deliveryStatus, badgeVariant, 'delivery')
		: getOrderDeliveryStatusBadgeProps(deliveryStatus);

	if (!props || props.text === '-') {
		return <span>-</span>;
	}

	return <PendingListStatusBadge bg={props.bg} text={props.text} pill={props.pill} />;
};

export default OrderDeliveryStatusCell;
